import type * as Sentry from '@sentry/react';
import type { GraphQLError } from 'graphql';
import React from 'react';

import { GlobalHeader } from 'src/app/appLayout/components/globalHeader/GlobalHeader';
import { ErrorPage } from 'src/components/errorPage/ErrorPage';
import { ignorePermissionsErrors } from 'src/lib/apollo/catchErrors';

import { NotFound } from '../notFound/NotFound';

import { SharedErrorBoundary } from './SharedErrorBoundary';

interface Props {
  children: React.ReactNode;
  renderError?: (error: unknown) => React.ReactNode;
  extraErrorData?: () => Record<string, unknown>;
  sentryErrorLevel?: Sentry.SeverityLevel;
}

export const ErrorBoundary = ({ renderError, ...rest }: Props) => (
  <SharedErrorBoundary
    {...rest}
    fallback={({ error, eventId }) => {
      if (ignorePermissionsErrors(error as GraphQLError)) {
        // when the error is due to insufficient permissions, render the global nav to allow sudo fireflower to be available
        return (
          <>
            <GlobalHeader leftNavContext="collapsed" />
            <NotFound />
          </>
        );
      }

      return renderError ? (
        <>{renderError(error)}</>
      ) : (
        <ErrorPage error={error} errorId={eventId} />
      );
    }}
  />
);
